import React, { useState } from 'react';
import { Settings, Eye, EyeOff, Plus, ShieldCheck, Info } from 'lucide-react';
import { attributsEquipements } from '../data/mockData';

const Parametres = () => {
  const [attributs, setAttributs] = useState(attributsEquipements);

  const toggle = (nom) => {
    setAttributs((prev) =>
      prev.map((a) => (a.nom === nom ? { ...a, confidentiel: !a.confidentiel } : a))
    );
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Parametres des attributs</h1>
          <p className="page-subtitle">Marquage standard ou confidentiel des attributs d equipements</p>
        </div>
        <button className="btn-primary">
          <Plus size={16} /> Nouvel attribut
        </button>
      </div>

      <div className="info-banner">
        <Info size={18} />
        <p>
          Par defaut, les attributs ajoutes via les matrices Excel sont <strong>standards</strong> (visibles par tous les
          utilisateurs en consultation). Cochez <strong>Confidentiel</strong> pour qu un attribut ne soit visible que par
          les <strong>administrateurs</strong> (infobulles et fiches equipement le masquent aux autres profils).
        </p>
      </div>

      <div className="card">
        <header className="card-header">
          <div className="card-title">
            <Settings size={18} />
            <h2>Attributs references ({attributs.length})</h2>
          </div>
        </header>
        <div className="card-body">
          <table className="data-table">
            <thead>
              <tr>
                <th>Nom de l attribut</th>
                <th>Description</th>
                <th>Confidentialite</th>
                <th>Visibilite</th>
                <th style={{ textAlign: 'right' }}></th>
              </tr>
            </thead>
            <tbody>
              {attributs.map((a) => (
                <tr key={a.nom}>
                  <td><strong>{a.nom}</strong></td>
                  <td>{a.description}</td>
                  <td>
                    <label className="toggle">
                      <input type="checkbox" checked={a.confidentiel} onChange={() => toggle(a.nom)} />
                      <span className="toggle-slider" />
                      <span className="toggle-label">Attribut confidentiel</span>
                    </label>
                  </td>
                  <td>
                    {a.confidentiel ? (
                      <span className="badge badge-warn"><EyeOff size={12} /> Admin uniquement</span>
                    ) : (
                      <span className="badge badge-ok"><Eye size={12} /> Tous utilisateurs</span>
                    )}
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <button className="btn-ghost btn-small">Modifier</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card" style={{ marginTop: '1.25rem' }}>
        <header className="card-header">
          <div className="card-title">
            <ShieldCheck size={18} />
            <h2>Comportement applique</h2>
          </div>
        </header>
        <div className="card-body info-grid">
          <div>
            <span className="info-label">Attributs standards</span>
            <span className="info-value">Visibles partout (infobulles, fiches, plan, tablette)</span>
          </div>
          <div>
            <span className="info-label">Attributs confidentiels</span>
            <span className="info-value">Masques pour les utilisateurs non-administrateurs</span>
          </div>
          <div>
            <span className="info-label">Source des attributs</span>
            <span className="info-value">Colonnes ajoutees dans la matrice Excel d un projet specialise</span>
          </div>
          <div>
            <span className="info-label">Alerte documents fournisseurs</span>
            <span className="info-value">Notification 30 jours avant expiration</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Parametres;
